import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const getWhatsAppLink = () => {
    const phoneNumber = process.env.REACT_APP_CONTACT_PHONE || '';
    // Remove any non-digit characters except +
    const cleanPhone = phoneNumber.replace(/[^\d+]/g, '');
    // Ensure it starts with country code (add + if not present)
    const formattedPhone = cleanPhone.startsWith('+') ? cleanPhone : `+${cleanPhone}`;
    // Get the default message in the current language
    const message = encodeURIComponent(t('whatsAppDefaultMessage'));
    return `https://wa.me/${formattedPhone.replace('+', '')}?text=${message}`;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const apiUrl = process.env.REACT_APP_API_BASE_URL || 'https://glowapp.foo-tech.net/api';
      const response = await fetch(`${apiUrl}/contact/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => setStatus(''), 5000);
      } else {
        setStatus('error');
        setTimeout(() => setStatus(''), 5000);
      }
    } catch (error) {
      setStatus('error');
      setTimeout(() => setStatus(''), 5000);
    }
  };

  return (
    <section id="contact" className="contact" aria-label="Contact section">
      <div className="container">
        <h2 className="section-title">{t('contactUs')}</h2>
        <p className="section-subtitle">{t('contactDescription')}</p>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon" aria-hidden="true">✉️</div>
              <div>
                <h3>{t('email')}</h3>
                <p><a href="mailto:support@glowapp.me" aria-label={`${t('email')}: support@glowapp.me`}>support@glowapp.me</a></p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon" aria-hidden="true">💬</div>
              <div>
                <h3>{t('whatsapp')}</h3>
                <a 
                  href={getWhatsAppLink()} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="whatsapp-button"
                  aria-label={`${t('sendWhatsAppMessage')} via WhatsApp`}
                >
                  {t('sendWhatsAppMessage')}
                </a>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">🗺️</div>
              <div>
                <h3>{t('address')}</h3>
                <p>Str. Garii 21A, Cluj-Napoca, Romania</p>
              </div>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">{t('name')}</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t('email')}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">{t('phone')}</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">{t('message')}</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? t('sending') : t('sendMessage')}
            </button>
            {status === 'success' && (
              <div className="form-status success">{t('messageSent')}</div>
            )}
            {status === 'error' && (
              <div className="form-status error">{t('messageError')}</div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
